module.exports = __webpack_public_path__ + "static/img/our-people-company-values-full-img.d3bfbce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-full-img.jpg
// module id = cszq
// module chunks = 0